export const templateRequestUpdateVi = [
    "Đơn này sai dimension, sửa đúng theo dimension 4200x4800",
    "Đơn này design trắng in lên nền áo trắng không nổi",
    "Đơn này design đen in lên nền áo đen không nổi",
    "Đơn này địa chỉ invalid",
    "Đơn này up nhầm mock up vào design",
    "Đơn này design khác mock up",
    "Đơn này thiếu design sleeve",
    "Đơn này up nhầm design sleeve vào back"
]

export const templateRequestUpdateEn = [
    "The artwork has the wrong dimension, change the artwork to 4200x4800 pixels",
    "White color from the artwork cannot be printed on a white shirt",
    "Black color from the artwork cannot be printed on a black shirt",
    "The order contains invalid address",
    "A mockup was mistakenly uploaded instead of an artwork",
    "The artwork is different from the mockup.",
    "The artwork for sleeve position is missing",
    "Artwork for the sleeve was mistakenly uploaded in back position"
]
